import React, { useState, useEffect, useContext } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CFormSelect,
  CButton,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { UserContext } from 'src/context/UserContext'
import { AdalatAPI } from './AdalatAPI'
import { CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { CONSTANTS } from 'src/constants'
import { convert_to_preeti } from 'src/helpers/PreetiConverter'

const initialState = {
  name: '',
  province: 1,
  status: 1,
  slug: null,
  address: '',
}

const AdalatForm = ({
  open,
  editMode,
  handleClose,
  editData,
  reload,
  setReload,
  fetching,
  selectedId,
}) => {
  // Response State
  const [response, setResponse] = useState({
    success: null,
    error: null,
  })
  // Adalat data
  const [adalatData, setAdalatData] = useState(initialState)

  // Lifecycle method to
  useEffect(() => {
    // console.log(editData)
    if (editData) {
      setAdalatData({
        name: editData.name,
        province: editData.province,
        slug: editData.slug,
        status: editData.status,
      })
    }
  }, [editData])

  useEffect(() => {
    if (open === false) {
      setResponse({
        success: null,
        error: null,
      })
    }
  }, [open])
  // User Context
  const [user] = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  // function to handle adalat data changes
  const handleAdalatDataChange = (e) => {
    setAdalatData({ ...adalatData, [e.target.name]: convert_to_preeti(e.target.value) })
  }

  // Function to create Adalat
  const handleSubmit = (e) => {
    e.preventDefault()

    if (adalatData.name === '') {
      return
    }
    setLoading(true)
    {
      editMode
        ? AdalatAPI.editAdalat(user.access_token, adalatData, selectedId)
            .then((res) => {
              if (res.data.status === true) {
                setAdalatData(initialState)
                setResponse({
                  error: null,
                  success: 'Adalat has been updated',
                })
                setLoading(false)
              } else {
                console.log(res.data)
                setResponse({
                  error: 'Failed to update',
                  success: null,
                })
                setLoading(false)
              }
            })
            .catch((e) => console.log(e.message))
        : AdalatAPI.createAdalat(user.access_token, adalatData)
            .then((res) => {
              if (res.data.status === true) {
                setLoading(false)
                setAdalatData(initialState)
                setResponse({
                  error: null,
                  success: 'New Adalat has been created',
                })
                setReload(!reload)
              }
            })
            .catch((e) => console.log(e.message))

      setTimeout(
        () =>
          setResponse({
            success: null,
            error: null,
          }),
        CONSTANTS.ALERT_TIME_OUT,
      )
    }
  }

  return (
    <CCard className="mb-4">
      <CCardHeader>{editMode ? 'Edit Adalat' : 'नयाँ अदालत'}</CCardHeader>
      <CCardBody>
        {response.success ? <Alert severity="success">{response.success}</Alert> : null}
        {response.error ? <Alert severity="error">{response.error}</Alert> : null}

        {fetching ? (
          <CircularProgress />
        ) : (
          <CForm className={response.success || response.error ? 'mt-4' : null}>
            <CRow>
              <CCol md="12">
                <div className="mb-3">
                  <CFormLabel htmlFor="adalatName">अदालत को नाम</CFormLabel>

                  <CFormInput
                    type="text"
                    id="adalatName"
                    placeholder=""
                    name="name"
                    value={adalatData.name}
                    onChange={handleAdalatDataChange}
                  />
                </div>
              </CCol>

              {/* <CCol md="6">
                <div className="mb-3">
                  <CFormLabel htmlFor="adalatName">अदालत को ठेगाना</CFormLabel>

                  <CFormInput
                    type="text"
                    id="adalatName"
                    placeholder=""
                    name="address"
                    value={adalatData.address}
                    onChange={handleAdalatDataChange}
                  />
                </div>
              </CCol> */}

              <CCol md="12">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <CButton type="submit" color="primary" size="sm" onClick={handleSubmit}>
                    {editMode ? 'Save' : 'अदालत बनाउनुहोस'}
                  </CButton>
                )}
                &nbsp;{' '}
                {editMode ? (
                  <CButton color="danger" size="sm" variant="outline" onClick={handleClose}>
                    Close
                  </CButton>
                ) : null}
              </CCol>
            </CRow>
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default AdalatForm

AdalatForm.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func,
}

AdalatForm.defaultProps = {
  editMode: false,
  handleClose: () => console.log('Clicked'),
}
